import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(with-layout)/(public)/(home)/home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageView"] */ "/app/src/components/context/analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/core/components/atoms/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LinguiClientProvider"] */ "/app/src/locales/index.tsx");
